"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ScrollSmoother", {
  enumerable: true,
  get: function () {
    return _all.ScrollSmoother;
  }
});
Object.defineProperty(exports, "ScrollTrigger", {
  enumerable: true,
  get: function () {
    return _all.ScrollTrigger;
  }
});
Object.defineProperty(exports, "gsap", {
  enumerable: true,
  get: function () {
    return _all.gsap;
  }
});
var _all = require("gsap/all");
if (typeof document !== 'undefined') {
  _all.gsap.registerPlugin(_all.ScrollTrigger, _all.ScrollSmoother);
  _all.gsap.registerEffect({
    name: 'fade',
    effect: (targets, config) => {
      return _all.gsap.fromTo(targets, {
        opacity: 0
      }, {
        opacity: 1,
        duration: config.duration,
        ease: 'power0.inOut',
        scrollTrigger: {
          trigger: config.trigger,
          start: '10% bottom'
        }
      });
    },
    defaults: {
      trigger: document.body,
      duration: 0.75
    },
    extendTimeline: true
  });
  _all.gsap.registerEffect({
    name: 'reveal',
    effect: (targets, config) => {
      return _all.gsap.to(targets, {
        opacity: 0,
        delay: config.delay,
        duration: config.duration,
        ease: 'power2.out'
      });
    },
    defaults: {
      delay: 3,
      duration: 0.25
    },
    extendTimeline: true
  });
  _all.gsap.registerEffect({
    name: 'horizontal',
    effect: (targets, config) => {
      return _all.gsap.to(targets, {
        x: config.x,
        ease: config.ease,
        scrollTrigger: {
          trigger: config.trigger,
          start: config.start,
          end: config.end,
          scrub: true,
          invalidateOnRefresh: true,
          pin: true,
          pinSpacing: config.pinSpacing,
          anticipatePin: config.anticipatePin,
          toggleClass: 'animation-transform'
        }
      });
    },
    defaults: {
      x: 0,
      ease: 'none',
      trigger: document.body,
      start: 'top top',
      end: 'bottom bottom',
      pinSpacing: true,
      anticipatePin: 0
    },
    extendTimeline: true
  });
  _all.gsap.registerEffect({
    name: 'sticky',
    effect: (targets, config) => {
      return _all.gsap.to(targets, {
        ease: config.ease,
        scrollTrigger: {
          trigger: config.trigger,
          start: config.start,
          endTrigger: config.endTrigger,
          end: config.end,
          scrub: true,
          invalidateOnRefresh: true,
          pin: true,
          pinSpacing: false,
          toggleClass: 'animation-transform'
        }
      });
    },
    defaults: {
      ease: 'none',
      trigger: document.body,
      start: 'top top',
      end: 'bottom bottom',
      endTrigger: document.body
    },
    extendTimeline: true
  });
  _all.gsap.registerEffect({
    name: 'rotation',
    effect: (targets, config) => {
      return _all.gsap.to(targets, {
        rotation: config.rotation,
        scrollTrigger: {
          trigger: config.trigger,
          start: config.start,
          end: config.end,
          scrub: config.scrub,
          toggleClass: 'animation-transform'
        }
      });
    },
    defaults: {
      rotation: 0,
      trigger: document.body,
      start: 'top top',
      end: 'bottom bottom',
      scrub: true
    },
    extendTimeline: true
  });
  _all.gsap.registerEffect({
    name: 'parallax',
    effect: (targets, config) => {
      return _all.gsap.fromTo(targets, {
        yPercent: `-${config.yPercent}`
      }, {
        yPercent: config.yPercent,
        ease: 'none',
        scrollTrigger: {
          trigger: config.trigger,
          scrub: 1,
          toggleClass: 'animation-transform'
        }
      });
    },
    defaults: {
      yPercent: 0,
      trigger: document.body
    },
    extendTimeline: true
  });
}
//# sourceMappingURL=index.js.map